import { createSelector } from '@reduxjs/toolkit'
import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'
import { IInstanceEvent } from '../types/InstanceEvent'

export const selectPaginatedItems = createSelector(
	[
		(store: StoreSchema) => store.instanceEvents.paginatedInstanceEvents.items,
		(store: StoreSchema) => store.instanceEvents.paginatedInstanceEvents.currentPage,
		(store: StoreSchema) => store.instanceEvents.limit,
		(store: StoreSchema) => store.instanceEvents.sort.sort,
		(store: StoreSchema) => store.instanceEvents.sort.direction
	],
	(items, currentPage, limit, sort, direction) => {
		let sorted = [...items] as IInstanceEvent[]

		if (sort && direction) {
			sorted.sort((a, b) => {
				const aVal = a[sort as keyof IInstanceEvent] as string
				const bVal = b[sort as keyof IInstanceEvent] as string

				if (aVal < bVal) return direction === 'ascending' ? -1 : 1
				if (aVal > bVal) return direction === 'ascending' ? 1 : -1
				return 0
			})
		}

		const start = (currentPage - 1) * limit
		const end = start + limit

		return sorted.slice(start, end)
	}
)